"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Component = void 0;
var Box_1 = __importDefault(require("@mui/material/Box"));
var Typography_1 = __importDefault(require("@mui/material/Typography"));
var Preact = __importStar(require("preact"));
var Button = __importStar(require("./A_Button"));
/**
 * Basic contents of the Confirmation Bar, which sits at the bottom of a Drawer.
 *
 * Always includes a Button, optionally includes some information text which sits alongside the button.
 */
var Component = function (p) {
    var _a, _b;
    return (Preact.h(Box_1.default, { sx: __assign({ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingX: '24px', paddingY: '22px' }, p.sx) },
        Preact.h(Box_1.default, { sx: { display: 'grid', gap: '4px' } },
            p.information1 ? Preact.h(Typography_1.default, { variant: "body1" }, p.information1) : null,
            p.information2 ? Preact.h(Typography_1.default, { variant: "h5" }, p.information2) : null),
        Preact.h(Button.Component, { color: "primary", variant: "contained", onClick: p.onClick, disabled: (_a = p.disabled) !== null && _a !== void 0 ? _a : false, size: "large", loading: (_b = p.loading) !== null && _b !== void 0 ? _b : false }, p.buttonText)));
};
exports.Component = Component;
exports.Component.displayName = 'DrawerCtaContentInfo';
